(function ($, Drupal) {
    Drupal.behaviors.setHighlight = {
        attach: function (context, settings) {
            // Get query param highlight.
            var urlParams = new URLSearchParams(window.location.search);
            var highlight = urlParams.get('search_api_fulltext');
            if (highlight) {
                jQuery('.grid--grid-search').children().find('a').each(function () {
                    var href = jQuery(this).attr('href');
                    if (href) {
                        jQuery(this).attr('href', href + '?highlight=' + highlight);
                    }
                });
            }
        }
    };
})(jQuery, Drupal);